var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { connect } from 'react-redux';
import ContainerlessButtonWidget from 'nucleus-widgets/lib/Button/ContainerlessButtonWidget';
import { routeToUrl, getPagePath, getCurrentPageId } from '../../redux/pathInfo';
import { getDefaultWebsitePageId } from '../../redux/website';
import { logoutRegistrant } from '../../redux/registrantLogin/actions';
import { showLoadingDialog, hideLoadingDialog, hideLoadingOnError } from 'nucleus-guestside-site/src/redux/modules/dialogContainer';
import { defaultRegistrationTypeId } from 'event-widgets/utils/registrationType';
import qs from 'querystring';
import { REGISTRATION, APPROVAL_DENIED, CANCELLATION, GUEST_REGISTRATION, PENDING_APPROVAL, POST_REGISTRATION, POST_REGISTRATION_PAYMENT } from '../../redux/website/registrationProcesses';
import { filterEventSnapshot } from '../../redux/actions';
import { getDefaultRegistrationPath } from 'event-widgets/redux/selectors/appData';
import { invalidateDatatagCache } from '../../utils/datatagUtils';
export var stripInviteeFromUrl = function (url) {
    var path = url.split('?')[0];
    var query = qs.parse(url.split('?')[1]) || {};
    delete query.inviteeId;
    // The i query param is the incoded version of the inviteeId.
    delete query.i;
    // The tm query param store a hash for test mode
    delete query.tm;
    // we need to delete marketo and eloqua param from url on log out
    delete query.MarketoID;
    delete query.EloquaID;
    return path + (Object.keys(query).length ? "?" + qs.stringify(query) : '');
};
function currentPageNeedsLoggedInUser(state) {
    return (REGISTRATION.isTypeOfCurrentPage(state) ||
        GUEST_REGISTRATION.isTypeOfCurrentPage(state) ||
        POST_REGISTRATION.isTypeOfCurrentPage(state) ||
        CANCELLATION.isTypeOfCurrentPage(state) ||
        PENDING_APPROVAL.isTypeOfCurrentPage(state) ||
        APPROVAL_DENIED.isTypeOfCurrentPage(state) ||
        POST_REGISTRATION_PAYMENT.isTypeOfCurrentPage(state));
}
function logout() {
    var _this = this;
    return function (dispatch, getState) { return __awaiter(_this, void 0, Promise, function () {
        var state, eventSnapshotVersion, appData, defaultRegPathId, nextPageId, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(showLoadingDialog());
                    state = getState();
                    eventSnapshotVersion = state.eventSnapshotVersion, appData = state.appData;
                    defaultRegPathId = getDefaultRegistrationPath(appData);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 7, , 8]);
                    return [4 /*yield*/, dispatch(logoutRegistrant())];
                case 2:
                    _a.sent();
                    // after logout is complete, reset website to default regTypeId and default regPathId
                    return [4 /*yield*/, dispatch(filterEventSnapshot(eventSnapshotVersion, defaultRegistrationTypeId, defaultRegPathId))];
                case 3:
                    // after logout is complete, reset website to default regTypeId and default regPathId
                    _a.sent();
                    state = getState();
                    nextPageId = currentPageNeedsLoggedInUser(state) ? getDefaultWebsitePageId(state) : getCurrentPageId(state);
                    if (!state.defaultUserSession.isTestMode) return [3 /*break*/, 4];
                    // setting href instead of using replace so that back button works correctly
                    global.location.href = stripInviteeFromUrl(getPagePath(state, nextPageId));
                    return [3 /*break*/, 6];
                case 4: return [4 /*yield*/, dispatch(routeToUrl(stripInviteeFromUrl(getPagePath(state, nextPageId))))];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6: return [3 /*break*/, 8];
                case 7:
                    error_1 = _a.sent();
                    dispatch(hideLoadingOnError());
                    throw error_1;
                case 8:
                    dispatch(hideLoadingDialog());
                    invalidateDatatagCache();
                    return [2 /*return*/];
            }
        });
    }); };
}
export function mapStateToProps() {
    return {
        kind: 'button'
    };
}
export var mapDispatchToProps = {
    clickHandler: logout
};
/**
 * Data wrapper for the log out widget.
 */
export default connect(mapStateToProps, mapDispatchToProps)(ContainerlessButtonWidget);
